import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      {/* Hero with two initiative blurbs side by side */}
      <section className="home-hero">
        <div className="container">
          <div className="home-intro">
            <div className="home-logos">
              <img
                src="/images/kidney-reach-wordless.png"
                alt="Kidney ReACH Initiative logo"
                className="home-logo"
              />
               <img
                src="/images/reach-wordless.png"
                alt="ReACH Initiative logo"
                className="home-logo"
              />
            </div>
            <h1>Advancing Reproductive, Cardiovascular &amp; Kidney Health</h1>
            <p className="home-lede">
              Patient-partnered research investigating how reproductive events,
              diseases, and hormones shape cardiovascular and kidney health for
              all individuals.
            </p>
          </div>

          <div className="home-initiatives">
            <article className="initiative-card">
              <div className="initiative-image">
                <img
                  src="/images/kidney-reach.png"
                  alt="The Kidney ReACH Initiative"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <div className="initiative-body">
                <h2>The Kidney ReACH Initiative</h2>
                <p>
                  The Kidney ReACH (Reproductive And Cardiovascular Health)
                  Initiative examines how reproductive health factors
                  intersect with kidney and cardiovascular health in
                  all individuals. Through engagement with patient partners,
                  we also address reproductive health challenges specific to
                  chronic kidney disease and co-develop strategies to address
                  important gaps in knowledge and care.
                </p>
              </div>
            </article>
            <article className="initiative-card">
              <div className="initiative-image">
                <img
                  src="/images/reach.png"
                  alt="The ReACH Initiative"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <div className="initiative-body">
                <h2>The ReACH Initiative</h2>
                <p>
                  The ReACH (Reproductive And Cardiovascular Health)
                  Initiative investigates how reproductive events, diseases,
                  and hormones shape cardiovascular health. In collaboration
                  with patient partners, we identify priorities, address
                  knowledge gaps, and develop strategies to improve
                  cardiovascular outcomes for all individuals.
                </p>
              </div>
            </article>

          </div>

          <div className="home-donate" id="donate">
            <a
              href="https://engage.ucalgary.ca/KidneyReACHInitiative"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Donate to Kidney ReACH
            </a>
            <a
              href="https://engage.ucalgary.ca/ReACHInitiative"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Donate to ReACH
            </a>
          </div>

          <div className="home-actions">
            <Link to="/participate" className="btn btn-secondary">
              Participate in Our Research
            </Link>
            <Link to="/people" className="btn btn-secondary">
              Meet the Team
            </Link>
          </div>
        </div>
      </section>

      {/* Land acknowledgment */}
      <section className="home-acknowledgment">
        <div className="container-narrow">
          <span className="home-eyebrow">Land Acknowledgment</span>
          <div className="acknowledgment-body">
            <p>
              The University of Calgary, located in the heart of Southern
              Alberta, both acknowledges and pays tribute to the traditional
              territories of the peoples of Treaty 7, which include the
              Blackfoot Confederacy (comprised of the Siksika, the Piikani, and
              the Kainai First Nations), the Tsuut'ina First Nation, and the
              Stoney Nakoda (including Chiniki, Bearspaw, and Goodstoney First
              Nations). The city of Calgary is also home to the Métis Nation
              within Alberta (including Nose Hill Métis District 5 and Elbow
              Métis District 6).
            </p>
            <p>
              The University of Calgary is situated on land Northwest of where
              the Bow River meets the Elbow River, a site traditionally known
              as Moh'kins'tsis to the Blackfoot, Wîchîspa to the Stoney Nakoda,
              and Guts'ists'i to the Tsuut'ina. On this land and in this place
              we strive to learn together, walk together, and grow together
              "in a good way."
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;